module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Digital-Flyer-CANADA.ace68ca5.pdf";